export default {
  data() {
    return {};
  },
  id: 'b754355270',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page form-page">\r\n        <div class="navbar paymentPage no-shadow">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner navbar-inner-large">\r\n              <div class="left">\r\n                <a href="#" class="link back">\r\n                  <i class="icon f7-icons text-color-blue">chevron_left</i>\r\n                </a>\r\n              </div>\r\n              <div class="title text-color-blue">Add money into wallet</div>\r\n              <!-- large title element -->\r\n              <div class="title-large">\r\n                <div class="title-large-text text-color-blue">Add money into wallet</div>\r\n              </div>\r\n            </div>\r\n        </div>\r\n        <div class="page-content">\r\n            <h3 class="text-color-blue margin-left">Choose bank account</h3>\r\n            <div class="block-virtual-account">\r\n                <div class="list media-list no-hairlines">\r\n                    <ul>\r\n                      \r\n                    </ul>\r\n                </div> \r\n            </div>\r\n            <div class="list media-list list__payProcessing">\r\n                <ul class="color-logo">\r\n                    <li>\r\n                        <div class="item-link item-content">\r\n                        <div class="item-media"><img src="assets/icons/info.png" width="40"/></div>\r\n                        <div class="item-inner">\r\n                        <div class="item-text text-color-red f-14 depositLimit"></div>\r\n                        </div>\r\n                        </div>\r\n                    </li>\r\n                  </ul> \r\n            </div>\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  styleScoped: false
};